const UiEvents = [
    'uiReady',
    'uiPluginInserted',
    'uiPluginOpen',
    'uiPluginClose',
];

export default UiEvents;



// WEBPACK FOOTER //
// ./src/js/events/ui-events.js